import React, { useEffect, useRef, useState } from 'react';
import { departmentKeyValue1 } from '../../services';
import toast from 'react-hot-toast';
import Select from 'react-select';
import { DailyConsumptionReport, resturantWipReport } from '../../services/Purchase/Reports';
import { Button } from 'react-bootstrap';
import { getFormattedNumber } from '../utils/textUtils';
import { consumptionVsCurrentStock } from '../../services/Report/ReportServices';
import Loader from '../Common/Loader';
import { Toaster } from "react-hot-toast";
import { getRestaurantKeyValueList } from '../../services/Settings/WarehouseService';
import { RestaurantDepartmentKeyValue } from '../../services/Settings/PreferenceService';
import { useDownloadExcel } from "react-export-table-to-excel";
import AssessmentIcon from "@mui/icons-material/Assessment";

const RestaurantReport = () => {
    const urlParams = new URLSearchParams(window.location.search);
    var curr = new Date();
    curr.setDate(curr.getDate());
    var date1 = curr.toISOString().substring(0, 10);
    var curr1 = new Date();
    curr1.setDate(1);
    var date2 = curr1?.toISOString().substring(0, 10)
    const restaurantId = urlParams.get("restaurantId");
    const [startDate, setStartDate] = useState(date2);
    const [endDate, setEndDate] = useState(date1);
    const reportsOptions = [
        //    { label: 'Ingredients Consumption', value: 'Wip Report' },
        // { label: 'Consumption Vs Current Stock', value: 'Consumption Vs Current Stock' },
        { label: "Daily Ingredient Consumption", value: "Daily Ingredient Consumption" }
    ];

    const [ware, setWare] = useState('');
    const [wareOptions, setWareOptions] = useState([]);
    const [reports, setReports] = useState(reportsOptions);
    const [selectedReport, setSelectedReport] = useState(null);
    const [rows, setRows] = useState([]);
    const [resPacket, setResPacket] = useState([]);
    const [dept, setDept] = useState('');
    const [deptOptions, setDeptOptions] = useState([]);
    const [loading, setLoading] = useState(false);


    const handleReportSearch = () => {
        if (!selectedReport) {
            toast.error('Please select a report to view.');
            return;
        }

        let request = {};
        setLoading(true);
        if (selectedReport.value === 'Wip Report') {
            request.departmentId = dept?.value;
            request.warehouseId = ware?.value;
            request.startDate = startDate;
            request.endDate = endDate;
            resturantWipReport(request).then((res) => {
                if (res.errorCode === 0) {
                    handleApiResponse(res.responsePacket);
                    setLoading(false);
                } else {
                    toast.error('Failed to fetch Wip report data.');
                    setLoading(false);
                }
            }).catch(() => {
                toast.error('Failed to fetch Wip report data.');
                setLoading(false);
            });
        } else if (selectedReport.value === 'Consumption Vs Current Stock') {
            request.warehouseId = ware?.value;
            request.startDate = startDate;
            request.endDate = endDate;
            consumptionVsCurrentStock(request).then((res) => {
                if (res.errorCode === 0) {
                    handleApiResponse(res.responsePacket);
                    setLoading(false);
                } else if (res.errorCode === 1) {
                    toast.error('Failed to fetch Consumption report data.');
                    setLoading(false);
                }
            }).catch(() => {
                toast.error('Failed to fetch Consumption report data.');
                setLoading(false);
            });
        }
        else if (selectedReport.value === "Daily Ingredient Consumption") {
            request.warehouseId = ware?.value;
            request.startDate = startDate;
            request.endDate = endDate;
            DailyConsumptionReport(request).then((res) => {
                if (res.errorCode === 0) {
                    handleApiResponse(res.responsePacket);
                    setLoading(false);
                }
                else if (res.errorCode === 1) {
                    toast.error('Failed to fetch Consumption report data.');
                    setLoading(false);
                }
            })
                .catch(() => {
                    toast.error('Failed to fetch Consumption report data.');
                    setLoading(false);
                });
        }
    };

    useEffect(() => {
        setTimeout(() => {
            getRestaurantKeyValueList().then((res) => {
                if (res.errorCode === 0) {
                    const options = res.responsePacket.map((d) => ({
                        value: d.key,
                        label: d.value,
                    }));
                    if (restaurantId) {
                        const restaurantOption = options.find(option => option.value === restaurantId);
                        setWare(restaurantOption);
                    } else {
                        setWare(options[0]);
                    }
                    // const finalOptions = [{ label: "All", value: "" }, ...options];
                    // setWareOptions(finalOptions);
                    setWareOptions(options);
                } else {
                    toast.error(res.message);
                }
            });

            // departmentKeyValue1().then((res) => {
            //     if (res.errorCode === 0) {
            //         const options = res.responsePacket?.map((d) => ({
            //             value: d.key,
            //             label: d.value,
            //         }));
            //         setDept(options[0]);
            //         setDeptOptions(options);
            //     }
            // });
        },);
    }, [restaurantId]);


    useEffect(() => {
        if (ware?.value) {
            RestaurantDepartmentKeyValue({
                warehouseId: ware?.value
            }).then((res) => {
                if (res.errorCode === 0) {
                    const options = res.responsePacket?.map((d) => ({
                        value: d.key,
                        label: d.value,
                    }));
                    setDept(options[0]);
                    setDeptOptions(options);
                }
            });
        }
    }, [ware])

    const handleApiResponse = (response) => {
        if (response && response.length > 0) {
            setResPacket(response);
            setRows(response);
        } else {
            setResPacket([]);
            setRows([]);
            toast.error('No data found for the selected resturant.');
        }
    };

    const handleWarehouseSelect = (e) => {
        setWare(e);
    };

    const handleReportSelect = (e) => {
        setSelectedReport(e);
        setResPacket([]);
        setRows([]);
    };

    const toastDefaultOptionsStyle = {
        borderRadius: "5px",
        fontSize: "14px",
    };

    const componentRef = useRef();
    const { onDownload } = useDownloadExcel({
        currentTableRef: componentRef.current,
        filename: selectedReport?.value,
        sheet: "Users",
    });

    const handlePrintExcel = () => {
        setTimeout(() => {
            onDownload();
        }, 1000);
    };

    return (
        <>
            <div className="container-fluid pt-4">
                <div className="form-container d-flex justify-content-between align-items-center mb-4 border-bottom pb-2 position-relative" style={{ zIndex: '3' }}>
                    <Select
                        id="reportSelectOrg"
                        placeholder="Select Reports"
                        value={selectedReport}
                        onChange={(e) => handleReportSelect(e)}
                        options={reports}
                        className="flex-item mr-2"
                        style={{ minWidth: '200px' }}
                    />

                    {(selectedReport?.value === 'Consumption Vs Current Stock' ||
                        selectedReport?.value === 'Daily Ingredient Consumption') && (
                            <div className="d-flex" style={{ zIndex: '4' }}>
                                <Select
                                    id="reportSelectWare"
                                    placeholder="Select Warehouse"
                                    value={ware}
                                    onChange={(e) => handleWarehouseSelect(e)}
                                    options={wareOptions}
                                    className="flex-item mr-2 mx-4"
                                    style={{ minWidth: '200px' }}
                                />

                                {/* {restaurantId ?
                                <Select
                                    id="reportSelectWare"
                                    placeholder="Select Warehouse"
                                    value={ware}
                                    onChange={(e) => handleWarehouseSelect(e)}
                                    options={wareOptions}
                                    className="flex-item mr-2 mx-4"
                                    style={{ minWidth: '200px' }}
                                    isDisabled={restaurantId ? true : false}
                                /> :
                                <Select
                                    id="reportSelectWare"
                                    placeholder="Select Warehouse"
                                    value={ware}
                                    onChange={(e) => handleWarehouseSelect(e)}
                                    options={wareOptions}
                                    className="flex-item mr-2 mx-4"
                                    style={{ minWidth: '200px' }}
                                />
                            } */}

                                {/* <div className="flex-item" style={{ minWidth: '200px' }}>
                                {deptOptions && (
                                    <Select
                                        id="reportSelectDept"
                                        placeholder="Select Department"
                                        value={dept}
                                        onChange={(e) => setDept(e)}
                                        options={deptOptions}
                                        className="flex-item mr-2 mx-4"
                                    />
                                )}
                            </div> */}
                                <div className="mx-2 d-flex flex-item" style={{ minWidth: '200px' }}>
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text font-weight-bold"
                                            id="basic-addon1"
                                        >
                                            Start:
                                        </span>
                                    </div>
                                    <input
                                        autoComplete="off"
                                        className=" form-control"
                                        type="date"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                </div>
                                <div className="d-flex flex-item" style={{ minWidth: '200px' }}>
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text font-weight-bold"
                                            id="basic-addon1"
                                        >
                                            End:
                                        </span>
                                    </div>
                                    <input
                                        autoComplete="off"
                                        className=" form-control"
                                        type="date"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                </div>
                            </div>
                        )}
                    {/* {selectedReport?.value === "Daily Ingredient Consumption" && (
                        <div className="d-flex" style={{ zIndex: '4' }}>
                            <div className="mx-2 d-flex flex-item" style={{ minWidth: '200px' }}>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text font-weight-bold"
                                        id="basic-addon1"
                                    >
                                        Start:
                                    </span>
                                </div>
                                <input
                                    autoComplete="off"
                                    className=" form-control"
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </div>
                            <div className="d-flex flex-item" style={{ minWidth: '200px' }}>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text font-weight-bold"
                                        id="basic-addon1"
                                    >
                                        End:
                                    </span>
                                </div>
                                <input
                                    autoComplete="off"
                                    className=" form-control"
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </div>
                        </div>
                    )} */}
                    {selectedReport && <div>
                        <Button
                            className="btn btn-primary font-size-14 py-2 text-light"
                            onClick={handleReportSearch}
                        >
                            Search
                        </Button>
                        <button
                            className="btn hoverBtn p-1"
                            // onClick={handlePrint}
                            onClick={handlePrintExcel}
                        >
                            <AssessmentIcon style={{ fontSize: '22px' }} />
                        </button>
                    </div>}
                </div>
                <div ref={componentRef} id="pdf" >
                    {selectedReport?.value === 'Wip Report' && (
                        loading ? (<Loader />) :
                            (<div className="table-container mt-4">
                                <h3 className="mb-3 fs-5">Ingredients Consumption Report</h3>
                                {resPacket?.length === 0 ? (
                                    <div className="text-center">
                                        No records found.
                                    </div>
                                ) : (
                                    <table className="customTable newcustomtable w-100">
                                        <thead>
                                            <tr>
                                                <th>S. No</th>
                                                <th>BATCH NO.</th>
                                                <th>MFG DATE</th>
                                                <th>EXPIRY DATE</th>
                                                <th>ITEM CODE</th>
                                                <th style={{ width: "20%" }}>ITEM NAME</th>
                                                <th className="text-center">QTY</th>
                                                <th>UOM</th>
                                                <th>PURCHASE PRICE</th>
                                                <th>ALT QTY</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {resPacket?.map((row, i) => (
                                                <tr key={i} style={{ cursor: 'pointer' }}>
                                                    <td>{i + 1}</td>
                                                    <td>{row.batchNumber}</td>
                                                    <td>{row.mfgDate}</td>
                                                    <td>{row.expDate}</td>
                                                    <td>{row.itemCode}</td>
                                                    <td style={{ width: "20%" }}>{row.itemTitle}</td>
                                                    <td className="text-right">{getFormattedNumber(row.qty)}</td>
                                                    <td>{row.uom}</td>
                                                    <td>{getFormattedNumber(row.itemPurchasePrice)}</td>
                                                    <td>{row.altQty}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>)
                    )}

                    {selectedReport?.value === 'Consumption Vs Current Stock' && (
                        loading ? (<Loader />) :
                            (<div>
                                <h3 className="mb-3 fs-5">Consumption Vs Current Stock</h3>
                                {resPacket && resPacket?.length > 0 ? (
                                    <table className="customTable newcustomtable w-100">
                                        <thead>
                                            <tr>
                                                <th>S. No</th>
                                                <th className="pl-4">Item Name</th>
                                                <th className="pl-4">Current Stock</th>
                                                <th className="pl-4">consumedStock</th>
                                                <th className="pl-4">UOM</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {resPacket?.map((row, i) => (
                                                <tr key={i}>
                                                    <td>{i + 1}</td>
                                                    <td>{row.ingredientName}</td>
                                                    <td>{row.currentStock}</td>
                                                    <td>{row.consumedStock}</td>
                                                    <td>{row.unit}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <div className="my-3 text-black text-center">No Records Found</div>
                                )}
                            </div>)
                    )}
                    {selectedReport?.value === 'Daily Ingredient Consumption' && (
                        loading ? (<Loader />) :
                            (<div>
                                <h3 className="mb-3 fs-5">Daily Ingredient Consumption Report</h3>
                                {resPacket && resPacket?.length > 0 ? (
                                    <table className="customTable newcustomtable w-100">
                                        <thead>
                                            <tr>
                                                <th style={{ width: "100px" }}>S. No</th>
                                                <th className="pl-4">Ingredient Name</th>
                                                <th className="pl-4">Category Name</th>
                                                <th className="pl-4">Qty</th>
                                                <th className="pl-4">Unit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {resPacket?.map((row, i) => (
                                                <tr key={i}>
                                                    <td style={{ width: "100px" }}>{i + 1}</td>
                                                    <td>{row.ingredientName}</td>
                                                    <td>{row.categoryName}</td>
                                                    <td>{row.totalQuantityUsed}</td>
                                                    <td>{row?.unit}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <div className="my-3 text-black text-center">No Records Found</div>
                                )}
                            </div>)
                    )}
                </div>
            </div>
            <Toaster
                toastOptions={{
                    duration: 2000,
                    style: toastDefaultOptionsStyle,
                }}
            />
        </>
    );
};

export default RestaurantReport;
